import React from 'react';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';

export const Contact = () => {
  return (
    <div data-testid="contact-page">
      {/* Hero Section */}
      <section className="relative py-32 bg-[#005B96]" data-testid="contact-hero">
        <div className="absolute inset-0 bg-[url('https://customer-assets.emergentagent.com/job_plumbing-heating-ns/artifacts/qskuuchf_FB_IMG_1771192477688.jpg')] bg-cover bg-center opacity-10" />
        <div className="relative container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white/90 text-sm font-semibold mb-6">
              Contact Us
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-6">
              Contact Your Local Yarmouth Plumber
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Get in touch with Duncan's Plumbing Heating & Filtration for all your plumbing, heating, and water filtration needs.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-20 md:py-28 bg-white" data-testid="contact-content">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Get In Touch
            </h2>
            <p className="text-gray-600 text-lg">
              We're here to help with all your plumbing, heating, and water filtration needs. Reach out today!
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Phone */}
            <div className="flex flex-col items-center text-center p-8 bg-slate-50 rounded-2xl">
              <div className="w-16 h-16 bg-[#005B96] rounded-xl flex items-center justify-center mb-4">
                <Phone size={28} className="text-white" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Phone</h3>
              <a
                href="tel:902-746-0554"
                className="text-[#005B96] font-semibold text-xl hover:underline"
                data-testid="contact-phone-link"
              >
                902-746-0554
              </a>
              <p className="text-gray-500 text-sm mt-2">Available 24/7 for emergencies</p>
            </div>

            {/* Email */}
            <div className="flex flex-col items-center text-center p-8 bg-slate-50 rounded-2xl">
              <div className="w-16 h-16 bg-[#005B96] rounded-xl flex items-center justify-center mb-4">
                <Mail size={28} className="text-white" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Non-Emergency Email</h3>
              <a
                href="mailto:duncansplumbing.dm@gmail.com"
                className="text-[#005B96] font-semibold hover:underline break-all"
                data-testid="contact-email-link"
              >
                duncansplumbing.dm@gmail.com
              </a>
              <p className="text-gray-500 text-sm mt-2">Email is not monitored for urgent or emergency plumbing issues. Please call for immediate service.</p>
            </div>

            {/* Address */}
            <div className="flex flex-col items-center text-center p-8 bg-slate-50 rounded-2xl">
              <div className="w-16 h-16 bg-[#005B96] rounded-xl flex items-center justify-center mb-4">
                <MapPin size={28} className="text-white" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Address</h3>
              <p className="text-gray-700" data-testid="contact-address">
                632 Main St<br />
                Yarmouth, NS B5A 1K3
              </p>
              <p className="text-gray-500 text-sm mt-2">Serving Yarmouth, Digby & Shelburne Counties</p>
            </div>

            {/* Hours */}
            <div className="flex flex-col items-center text-center p-8 bg-slate-50 rounded-2xl">
              <div className="w-16 h-16 bg-[#005B96] rounded-xl flex items-center justify-center mb-4">
                <Clock size={28} className="text-white" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Service Hours</h3>
              <p className="text-gray-700">
                Monday - Friday: 8am - 5pm
              </p>
              <p className="text-gray-500 text-sm mt-2">Emergency Service: 24/7</p>
            </div>
          </div>

          {/* Emergency CTA */}
          <div className="mt-12 p-8 bg-[#E6F2FA] rounded-2xl text-center">
            <h3 className="font-bold text-2xl text-gray-900 mb-3">Need Emergency Service?</h3>
            <p className="text-gray-600 mb-6">
              Plumbing emergencies don't wait. Call us anytime for immediate assistance.
            </p>
            <a
              href="tel:902-746-0554"
              className="inline-flex items-center gap-2 bg-[#005B96] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#004a7a] transition-all"
              data-testid="emergency-cta"
            >
              <Phone size={20} />
              <span>Call Now – 902-746-0554</span>
            </a>
          </div>
        </div>
      </section>

      {/* Sticky Mobile CTA */}
      <div className="sticky-cta md:hidden">
        <a
          href="tel:902-746-0554"
          className="flex items-center justify-center gap-2 bg-[#005B96] text-white w-full py-4 rounded-full font-bold"
        >
          <Phone size={20} />
          <span>Call Now – 902-746-0554</span>
        </a>
      </div>
    </div>
  );
};

export default Contact;
